import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { StgApproveRequest } from '../../types/account'
import api from '../../api'

const useStgApproveAccount = (accountRequestID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload: StgApproveRequest) => api.accounts.stgApproveAccount(payload),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['accounts'] })
			queryClient.invalidateQueries({ queryKey: ['accounts', accountRequestID] })
		}
	})
}

export default useStgApproveAccount
